/**
 * Check if a string is empty, null, undefined, or contains only whitespace.
 *
 * @param value - The value to check
 * @returns true if the string is empty, null, undefined, or whitespace-only
 */
export function isStringEmpty(value: unknown): boolean {
  return !value || typeof value !== 'string' || value.trim() === ''
}

/**
 * Check if a string is NOT empty (has actual content after trimming).
 *
 * @param value - The value to check
 * @returns true if the string has content after trimming
 */
export function isStringNotEmpty(value: unknown): boolean {
  return !isStringEmpty(value)
}
